import { Box, Typography } from "@mui/material";
import { ReactComponent as ArrowLeftGreen } from "../../assets/icons/arrow-left-green.svg";
import { useNavigate } from "react-router-dom";
import ReferralBg from "../../assets/images/refferal-bg.svg";

function ReferralBanner({ sx = [], ...props }) {
  const { campaign } = props;
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => {
        navigate("/app/profile/referral");
      }}
      sx={{
        width: "100%",
        p: "12px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Box
        mt={1}
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          overflow: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Typography
          align="center"
          variant="h5"
          color="grey.3"
          fontSize="12px"
          sx={{ whiteSpace: "pre-line" }}
        >
          {campaign.slogan}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minHeight: 32,
            px: "18px",
            lineHeight: "18px",
            borderRadius: "8px",
            bgcolor: "secondary.main",
          }}
        >
          <Typography variant="h6" color="common.white">
            دریافت جایزه{" "}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          pl: 1,
        }}
      >
        <img src={ReferralBg} width={137} height={127} />
      </Box>
    </Box>
  );
}

export default ReferralBanner;
